<template>
  <HeadlineComponent>{{ name }} bearbeiten</HeadlineComponent>
  <Form @submit="save" class="form-horizontal" :initialValues="webhook" v-if="loaded">
    <div class="form-row">
      <div class="form-group col-sm">
        <label for="name">Name</label>
        <BootstrapField type="text" name="name" placeholder="Name" rules="required" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm">
        <label for="endpoint">Endpunkt</label>
        <BootstrapField type="text" name="endpoint" placeholder="endpoint" rules="required" />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm">
        <label for="method">Methode</label>
        <Field name="method" rules="required" v-slot="{ field, errors, errorMessage, meta }">
          <select v-bind="field" class="form-control"
            :class="{ 'is-invalid': !!errors.length, 'is-valid': meta.valid && meta.dirty }">
            <option :value="-1">--- Auswählen ---</option>
            <option :value="0">GET</option>
            <option :value="1">POST</option>
            <option :value="2">PUT</option>
          </select>
          <span class="invalid-feedback" v-if="!!errors.length">{{ errorMessage }}</span>
        </Field>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm">
        <label for="method">Event</label>
        <Field name="event_id" v-slot="{ field, errors, errorMessage, meta }">
          <select v-bind="field" class="form-control"
            :class="{ 'is-invalid': !!errors.length, 'is-valid': meta.valid && meta.dirty }">
            <option value="">--- Keins ---</option>
            <option v-for="event of events" :key="event.id" :value="event.id">{{ event.name }}</option>
          </select>
          <span class="invalid-feedback" v-if="!!errors.length">{{ errorMessage }}</span>
        </Field>
      </div>
    </div>
    <div class="form-row mt-4">
      <div class="form-group col-sm">
        <LoadingButton class="btn-primary" :loading="loading">Speichern</LoadingButton>
      </div>
    </div>
  </form>
</template>

<script>
import webhookService from "../services/webhook.service.js";
import { useAlertsStore } from "../stores/alerts.js";
import { mapActions } from "pinia";
import router from "../router";
import HeadlineComponent from "../components/HeadlineComponent.vue";
import eventService from "../services/event.service";
import { Form, Field } from 'vee-validate';
import BootstrapField from "@/components/BootstrapField.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import { setErrors } from '@/helper/ErrorToActions.js';
import * as Sentry from '@sentry/vue';

export default {
  name: "UpdateWebhookView",
  components: { HeadlineComponent, Form, BootstrapField, LoadingButton, Field },
  data() {
    return {
      webhook: {},
      name: "",
      events: [],
      loading: false,
      loaded: false
    };
  },
  async beforeMount() {
    try {
      let response = await webhookService.get(this.$route.params.id);
      this.webhook = response.data;
      this.name = response.data.name;
      response = await eventService.index();
      this.events = response.data;
    }
    catch (e) {
      if (e) {
        Sentry.captureException(e);
        this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
    this.loaded = true;
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async save(form, actions) {
      this.loading = true;
      try {
        await webhookService.update(this.webhook.id, form);
        this.addAlert("success", "Webhook erfolgreich gespeichert");
        router.push("/settings/webhook");
      }
      catch (e) {
        if (e) {
          if (e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions)
            this.loading = false;
            return
          }
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped></style>